var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './vitesse-icon';
export const DEFAULT_SORT_MODES = [
    { key: 'name', dir: 'asc', icon: 'arrow-down-wide-narrow', label: 'Name (A→Z)' },
    { key: 'name', dir: 'desc', icon: 'arrow-down-narrow-wide', label: 'Name (Z→A)' },
    { key: 'type', dir: 'asc', icon: 'arrow-up-narrow-wide', label: 'Type (A→Z)' },
    { key: 'type', dir: 'desc', icon: 'arrow-up-wide-narrow', label: 'Type (Z→A)' },
];
let VitesseSortCycle = class VitesseSortCycle extends LitElement {
    constructor() {
        super(...arguments);
        /** The cycle. Defaults to Name↑/↓ then Type↑/↓. */
        this.modes = DEFAULT_SORT_MODES;
        /** Current mode index (also the resting default when 0). */
        this.index = 0;
    }
    static { this.styles = css `
    :host {
      display: inline-flex;
    }
    /* the ONE icon-button treatment: flat, grow on hover, blue on hover */
    button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 4px;
      border: none;
      background: transparent;
      color: var(--text-secondary);
      cursor: pointer;
      border-radius: 6px;
      transition:
        transform 0.12s ease,
        color 0.12s ease;
    }
    button:hover {
      color: var(--blue);
      transform: scale(1.07);
    }
    /* off the resting default → tint blue so it's clear a sort is active */
    button.active {
      color: var(--blue);
    }
  `; }
    cycle() {
        this.index = (this.index + 1) % this.modes.length;
        this.emit();
    }
    emit() {
        const m = this.modes[this.index];
        if (!m)
            return;
        this.dispatchEvent(new CustomEvent('sort-change', { detail: { key: m.key, dir: m.dir, index: this.index }, bubbles: true, composed: true }));
    }
    render() {
        const m = this.modes[this.index] ?? this.modes[0];
        if (!m)
            return html ``;
        return html `<button class=${this.index === 0 ? '' : 'active'} title=${`Sort: ${m.label}`} @click=${() => this.cycle()}>
      <vitesse-icon name=${m.icon} size="16"></vitesse-icon>
    </button>`;
    }
};
__decorate([
    property({ attribute: false })
], VitesseSortCycle.prototype, "modes", void 0);
__decorate([
    property({ type: Number })
], VitesseSortCycle.prototype, "index", void 0);
VitesseSortCycle = __decorate([
    customElement('vitesse-sort-cycle')
], VitesseSortCycle);
export { VitesseSortCycle };
//# sourceMappingURL=vitesse-sort-cycle.js.map